import { Fetch } from '@polvo-labs/react-auth'
import React from 'react'
import Chart from '../../../components/Chart'
import Icon from '../../../components/Icon'
import Card from '../Card'
import PageHeader from '../PageHeader'
import CardInfo from './CardInfo'
import { Charts, Numbers } from './styles'

export interface GetData {
  imoveis: { total: number, criado_em: string }[]
  usuarios: { total: number, criado_em: string }[]
}

// const getDateString = (date: Date) => {
//   const year = date.getUTCFullYear()
//   const month = (date.getUTCMonth() + 1).toString().padStart(2, '0')
//   const day = date.getUTCDate().toString().padStart(2, '0')

//   return `${year}-${month}-${day}`
// }

const getData = (days: number, data: GetData) => {
  
  return Object.keys(data.imoveis).map((key:any) => {
    const realtyTotal = data.imoveis[key]
    const userTotal = data.usuarios[key]
    return {
      name: key,
      'Imóveis': realtyTotal,
      'Usuários': userTotal,
    }
  })
}

interface Props {

}

const AdminScreen: React.FC<Props> = () => {
  return (
    <div>
      <PageHeader
        title="Visão Geral"
        subtitle="Dashboard"
      />
      <Fetch
        url={`${process.env.REACT_APP_API_URL}/dashboard`}
      >
        {({ data }) => data && data.data && (
          <>
            <Numbers>
              <CardInfo
                label="Cadastros"
                content={data.data.usuarios.cadastros.toString()}
                icon={(
                  <Icon
                    name="gender"
                    style={{
                      height: 26,
                      width: 26,
                    }}
                  />
                )}
              />
              <CardInfo
                label="Mensagens"
                content={data.data.mensagens.total.toString()}
                icon={(
                  <Icon
                    name="text"
                    style={{
                      height: 26,
                      width: 26,
                    }}
                  />
                )}
              />
              <CardInfo
                label="Imóveis cadastrados"
                content={data.data.imoveis.total}
                icon={(
                  <Icon
                    name="house"
                    style={{
                      height: 26,
                      width: 26,
                    }}
                  />
                )}
              />
              <CardInfo
                label="Imóveis aprovados"
                content={data.data.imoveis.aprovados.toString()}
                icon={(
                  <Icon
                    name="house"
                    style={{
                      height: 26,
                      width: 26,
                    }}
                  />
                )}
              />
            </Numbers>
            <Charts>
              <Card
                title="Atividade Semanal"
              >
                <Chart
                  type="bar"
                  data={{
                    data: getData(7, data.data.atvSemanal as GetData),
                    keys: [
                      'Imóveis',
                      'Usuários',
                    ],
                  }}
                />
              </Card>
              <Card
                title="Atividade Mensal"
              >
                <Chart
                  type="bar"
                  data={{
                    data: getData(30, data.data.atvMensal as GetData),
                    keys: [
                      'Imóveis',
                      'Usuários',
                    ],
                  }}
                />
              </Card>
            </Charts>
          </>
        )}
      </Fetch>
    </div>
  )
}

export default AdminScreen
